export const GlobalAbortController = typeof AbortController !== "undefined" ? AbortController : undefined;
//# sourceMappingURL=global-abort-controller.js.map